import type { ProductBrand } from '@@partner:types:app'

import React, { useCallback, useState } from 'react'
import { useDebounce } from 'use-debounce'

import { CheckPicker, SelectPicker } from 'rsuite'
import { useFetchAllShopTags } from '@@partner:graphql/query/shopTag/allShopTags.gql'
import { GQL_ID } from '@@partner:types:graphql'
import { ItemDataType } from 'rsuite/esm/MultiCascadeTree'

type ShopTagsPickerProps = {
  selectedTags?: GQL_ID[]
  onChange?: (tags?: GQL_ID[]) => void
}


export default function ShopTagsPicker ({
  selectedTags,
  onChange
}: ShopTagsPickerProps) {
  const [ searchName, setSearchName ] = useState('')
  const [ debouncedSearchName ] = useDebounce(searchName, 1000)

  const { data, loading, error } = useFetchAllShopTags({ 
    filter: {
      fields: [ 'name' ],
      op: searchName.length > 0 ? 'includes' : 'unwrap',
      value: debouncedSearchName
    }
  })

  const handleSearchNameChange = useCallback((value: string) => {
    setSearchName(value)
  }, [])

  const handleBrandsChange = useCallback(
    (value) => {
      
      onChange?.(value)
    },
    [ onChange ]
  )

  const handleBrandsClean = useCallback(() => {
    onChange?.()
  }, [ onChange ])

  const pickerData: ItemDataType<GQL_ID>[] = data?.allShopTags?.edges ?? (selectedTags ?? [])

  return (
    <div>
      <CheckPicker
        data={pickerData}
        value={selectedTags}
        onSearch={handleSearchNameChange}
        onClean={handleBrandsClean}
        onSelect={handleBrandsChange}
        labelKey="name"
        valueKey="id"
      />
    </div>
  )
}